import { render, staticRenderFns } from "./UserActivateUser.vue?vue&type=template&id=48de1544&scoped=true"
import script from "./UserActivateUser.vue?vue&type=script&lang=js"
export * from "./UserActivateUser.vue?vue&type=script&lang=js"
import style0 from "./UserActivateUser.vue?vue&type=style&index=0&id=48de1544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48de1544",
  null
  
)

export default component.exports